<template>
    <div class="page-content">
        <div class="banner" style="background-image: url()">
            <form>
                <div class="fields">
                    <input type="text" placeholder="Add Country or State" class="country" />
                    <input type="text" placeholder="Add an itinerary title" class="title" />
                    <textarea placeholder="Describe your itinerary. Make it inviting, catchy and unique!" class="description"></textarea>
                </div>

                <div class="upload-image">
                    <input type="file" ref="file" id="upload-banner" />
                    <button v-on:click.prevent="$refs.file.click()">
                        <i class="picture-icon"></i> Add a Cover Photo
                    </button>
                </div>
            </form>
        </div>

        <div class="section">
            <h2>
                <i class="calendar-icon"></i> Add travel period
            </h2>

            <form class="travel-dates"
                v-on:click="withTravelDate = true">
                <div class="field required">
                    <label>Number of Days</label>
                    <input type="number" placeholder="0" value="3" />
                </div>

                <div class="field">
                    <label>Select Dates</label>
                    <div class="dates-input">
                        <div class="input">
                            <input type="date" />
                            <i class="calendar-icon"></i>
                        </div> to
                        <div class="input">
                            <input type="date" />
                            <i class="calendar-icon"></i>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="section day" v-if="withActivity">
            <div class="title-and-pagination">
                <h3>Day 1
                    <button class="edit-btn">
                        <i class="edit-icon"></i> Add another day
                    </button>
                </h3>

                <div class="pagination">
                    <i class="arrow-icon dark prev inactive"></i>
                    <div class="content">1</div>
                    <i class="arrow-icon dark next"></i>
                </div>
            </div>
            <button class="remove-day-btn">Remove this day</button>

            <form class="activity-container">
                <button class="remove-activity-btn">
                    <i class="remove-icon"></i> Remove activity
                </button>

                <div class="field required">
                    <label>Title</label>
                    <input type="text" placeholder="Add a title" />
                </div>

                <div class="field required">
                    <label>Location</label>
                    <input type="text" placeholder="Search for the location" />
                </div>

                <div class="field required">
                    <label>Activity</label>
                    <input type="text" placeholder="Outdoors" />
                </div>

                <div class="field time-field">
                    <label>Time</label>
                    <div class="field-inputs">
                        <div class="input">
                            <input type="text" placeholder="Start time" />
                            <div class="buttons">
                                <div>
                                    <input type="radio" name="start-time" id="start-time-am" checked />
                                    <label for="start-time-am">AM</label>
                                </div>
                                <div>
                                    <input type="radio" name="start-time" id="start-time-pm" />
                                    <label for="start-time-pm">PM</label>
                                </div>
                            </div>
                        </div>
                        <div class="input">
                            <input type="text" placeholder="End time" />
                            <div class="buttons">
                                <div>
                                    <input type="radio" name="end-time" id="end-time-am" checked />
                                    <label for="end-time-am">AM</label>
                                </div>
                                <div>
                                    <input type="radio" name="end-time" id="end-time-pm" />
                                    <label for="end-time-pm">PM</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field budget-field">
                    <label>Budget</label>
                    <div class="field-inputs">
                        <div class="currency">USD</div>
                        <input type="text" placeholder="0.00" />
                    </div>
                </div>

                <div class="field">
                    <label>Description</label>
                    <textarea placeholder="Narrate your experience of the place"></textarea>
                </div>

                <div class="field">
                    <label>Photos</label>
                    <div class="drag-container">
                        <button>
                            <i class="picture-icon dark"></i> Click or drag to add photos
                        </button>
                    </div>
                </div>

                <div class="field">
                    <label>How did you get there</label>
                    <textarea placeholder="You can describe the mode of transportation you took, how long you travelled, the landmarks around the area to help fellow travellers"></textarea>
                </div>
            </form>

            <button class="add-more-btn">Add more Activities</button>

            <div class="activity-buttons">
                <button class="main-btn-outline">Save as Draft</button>
                <button class="main-btn"
                    v-on:click="confirmPublish">Publish Itinerary</button>
            </div>

            <button class="cancel-btn"
                v-on:click="confirmCancel">Cancel</button>

            <div class="pagination">
                <i class="arrow-icon dark prev inactive"></i>
                <div class="content">1</div>
                <i class="arrow-icon dark next"></i>
            </div>
        </div>

        <div class="section day no-activity"
            v-bind:class="{ 'no-travel-date': !withTravelDate }"
            v-else>
            <div class="title-and-pagination">
                <h3>Day 1
                    <button class="edit-btn">
                        <i class="edit-icon"></i>
                    </button>
                </h3>

                <div class="pagination">
                    <i class="arrow-icon dark prev inactive"></i>
                    <div class="content">1</div>
                    <i class="arrow-icon dark next"></i>
                </div>
            </div>

            <div class="rectangle"></div>
            <h4>You don’t have any activities yet</h4>

            <button class="main-btn add-more-btn"
                v-on:click="withActivity = true">Add Activity</button>
        </div>

        <PublishPopup v-if="openedPublishPopup"></PublishPopup>
        <CancelPopup v-if="openedCancelPopup"></CancelPopup>
    </div>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'CreateItinerary',
        components: {
            PublishPopup: require('./publishPopup').default,
            CancelPopup: require('./cancelPopup').default
        },
        data: function() {
            return {
                withTravelDate: false,
                withActivity: false,
                openedPublishPopup: false,
                openedCancelPopup: false
            }
        },
        methods: {
            confirmPublish: function() {
                this.openedPublishPopup = true
                document.querySelector('body').style.overflow = 'hidden'
            },
            confirmCancel: function() {
                this.openedCancelPopup = true
                document.querySelector('body').style.overflow = 'hidden'
            },
            closeAllPopups: function() {
                this.openedPublishPopup = false
                this.openedCancelPopup = false
                document.querySelector('body').style.overflow = 'auto'
            }
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'create-itinerary'
        },
        mounted: function() {
            let _this = this
            Eventbus.$on('closePublishPopup', _this.closeAllPopups)
            Eventbus.$on('closeCancelPopup', _this.closeAllPopups)
        }
    }
</script>

<style scoped lang="scss">
    .banner {
        position: relative;
        display: grid;
        padding: 65px 15px 15px;
        width: 100%;
        min-height: calc(100vw / 1440 * 677);
        color: #FFF;

        @media all and (max-width: $breakpoint) {
            padding-top: 50px + 30px;
            padding-bottom: 30px;
        }
    }

    .banner::before {
        content: "";
        background-color: rgba(#000, 0.5);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .banner > * {
        position: relative;
    }


    .banner form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }


    .banner .fields {
        width: 100%;
    }


    .banner [type="text"],
    .banner textarea {
        background-color: transparent;
        display: block;
        text-align: center;
        width: 100%;
        color: #FFF;

        &::placeholder {
            color: rgba(#FFF, 0.7);
        }
    }

    .banner .country {
        text-transform: uppercase;
        font-size: 20px;
        font-weight: $medium;
        letter-spacing: 5px;

        @media (min-width: $breakpoint + 1) and (max-width: 860px) {
            font-size: 16px;
        }

        @media all and (max-width: $breakpoint) {
            font-size: 14px;
        }
    }

    .banner .title {
        margin-top: 20px;
        font-family: 'Georgia', sans-serif;
        font-weight: bold;
        font-size: 48px;

        @media (min-width: $breakpoint + 1) and (max-width: 860px) {
            font-size: 36px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            font-size: 20px;
        }
    }

    .banner textarea {
        margin-top: 16px;
        height: 28px;
        line-height: 28px;
        font-size: 20px;

        @media (min-width: $breakpoint + 1) and (max-width: 860px) {
            font-size: 16px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 7px;
            line-height: 20px;
            font-size: 14px;
            height: 52px;
        }
    }


    .upload-image {

        @media all and (min-width: 1041px) {
            position: absolute;
            right: 90px;
            bottom: 54px;
        }

        @media all and (max-width: 1040px) {
            margin-top: 20px;
        }
    }


    .banner button {
        font-weight: $medium;
        font-size: 24px;
        color: #FFF;
        opacity: 0.7;

        @media all and (max-width: $breakpoint) {
            font-size: 14px;
        }
    }


    .banner [type="file"] {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
    }


    .banner .picture-icon {

        @media all and (min-width: $breakpoint + 1) {
            margin-right: 24px;
            width: 48px;
            height: 48px;
        }

        @media all and (max-width: $breakpoint) {
            margin-right: 8px;
            width: 24px;
            height: 24px;
        }
    }


    .section h2 {
        display: flex;
        justify-content: center;
        align-items: center;

        @media all and (min-width: $breakpoint + 1) {
            font-size: 36px;
        }
    }


    h2 .calendar-icon {
        margin-right: 24px;

        @media all and (min-width: $breakpoint + 1) {
            width: 56px;
            height: 56px;
        }

        @media all and (max-width: $breakpoint) {
            margin-right: 10px;
            width: 24px;
            height: 24px;
        }
    }

    .input .calendar-icon {
        position: absolute;
        top: 0;
        right: 16px;
        bottom: 0;
        margin: auto 0;
        width: 14px;
        height: 14px;
        pointer-events: none;
    }

    [type="date"]:hover + .calendar-icon {
        opacity: 0;
    }


    .travel-dates {
        font-size: 12px;

        @media all and (min-width: $breakpoint + 1) {
            display: flex;
            justify-content: center;
            margin-top: 36px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 40px;
        }
    }


    .travel-dates .field:not(:first-child) {

        @media all and (min-width: $breakpoint + 1) {
            margin-left: 50px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 16px;
        }
    }


    .travel-dates label {
        display: block;
        text-transform: uppercase;
        font-weight: $heavy;
        font-size: 12px;
    }

    .required label::after {
        content: "*";
        display: inline;
        margin-left: 4px;
        font-weight: $heavy;
        font-size: inherit;
        color: $accent-two;
    }


    .travel-dates [type="number"],
    .travel-dates [type="date"] {
        height: 36px;
        line-height: 36px;
        font-weight: $book;
        font-size: inherit;
        border: 1px solid $light-gray;
    }

    .travel-dates [type="number"] {
        margin-top: 8px;
        width: 100%;
        text-align: center;

        @media all and (min-width: $breakpoint + 1) {
            max-width: 109px;
        }
    }

    .travel-dates [type="date"] {
        padding: 0 0 0 16px;
        width: 140px;

        @media all and (max-width: $breakpoint) {
            width: 100%;
        }
    }


    .dates-input {
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: $dark-gray;
    }


    .dates-input .input {
        position: relative;

        @media all and (max-width: $breakpoint) {
            width: calc(50% - (12px + 6px));
        }
    }

    .dates-input .input:first-child {
        margin-right: 12px;
    }

    .dates-input .input:last-child {
        margin-left: 12px;
    }


    .section.day {
        margin-left: auto;
        margin-right: auto;
        max-width: 624px;
    }

    .section.no-activity {
        margin-top: 45px;
    }

    .section.no-travel-date {
        opacity: 0.2166;
        pointer-events: none;
    }


    .title-and-pagination {
        display: flex;
        justify-content: space-between;
        align-content: center;

        @media all and (max-width: $breakpoint) {
            flex-direction: column;
        }
    }


    .title-and-pagination h3 {
        display: flex;
        align-items: center;
        margin: 0;
        font-family: 'Georgia', sans-serif;
        font-weight: bold;
        font-size: 32px;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            order: 2;
            font-size: 20px;
        }
    }


    .edit-btn {
        margin-left: 16px;
        display: flex;
        align-items: center;
        font-family: 'Avenir', sans-serif;
        font-weight: $book;
        font-size: 12px;
        color: $accent;
        flex-shrink: 0;
    }


    .edit-btn .edit-icon {
        margin-right: 8px;

        @media all and (min-width: $breakpoint + 1) {
            width: 20px;
            height: 20px;
        }

        @media all and (max-width: $breakpoint) {
            width: 12px;
            height: 12px;
        }
    }


    .pagination {
        display: flex;
        align-items: center;

        @media all and (max-width: $breakpoint) {
            justify-content: center;
            order: 1;
        }
    }


    .pagination .content {
        margin: 0 16px;
        font-weight: $heavy;
        font-size: 20px;
    }


    .pagination .arrow-icon.inactive {
        opacity: 0.3;
        pointer-events: none;
    }


    .remove-day-btn {
        margin-top: 3px;
        font-weight: $book;
        font-size: 12px;
        color: $dark-gray;
    }


    .activity-container {
        position: relative;
        margin-top: 40px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .remove-activity-btn {
        position: absolute;
        top: 30px;
        left: calc(100% + 30px);
        white-space: nowrap;
        font-weight: $medium;
        font-size: 12px;
        color: $accent-two;

        @media all and (max-width: 940px) {
            top: -12px;
            left: auto;
            right: 0;
        }

        @media all and (max-width: $breakpoint) {
            top: 0;
        }
    }


    .remove-activity-btn .remove-icon {
        margin-right: 11px;

        @media all and (max-width: $breakpoint) {
            margin-right: 5px;
            width: 16px;
            height: 16px;
        }
    }


    .activity-container .field:not(:first-of-type) {
        margin-top: 24px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .activity-container label {
        display: block;
        text-transform: uppercase;
        font-weight: $medium;
        font-size: 12px;
    }


    .activity-container [type="text"],
    .activity-container textarea {
        padding: 0 24px;
        width: 100%;
        font-size: 14px;
        border: 1px solid $light-gray;

        @media all and (max-width: $breakpoint) {
            padding: 0 15px;
        }
    }

    .activity-container [type="text"] {
        height: 48px;
        line-height: 48px;
    }

    .activity-container .field > [type="text"],
    .activity-container textarea,
    .drag-container,
    .field-inputs {
        margin-top: 1px;

        @media all and (max-width: $breakpoint) {
            margin-top: 5px;
        }
    }

    .activity-container textarea {
        padding-top: 15px;
        padding-bottom: 15px;
        height: 183px;
    }


    .field-inputs {

        @media all and (min-width: $breakpoint + 1) {
            display: flex;
        }
    }

    .budget-field .field-inputs {
        position: relative;
    }


    .field-inputs .input,
    .field-inputs .buttons {
        display: flex;
    }

    .field-inputs .input {
        position: relative;
    }

    .field-inputs .input:not(:first-child) {

        @media all and (min-width: $breakpoint + 1) {
            margin-left: 24px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 5px;
        }
    }

    .field-inputs .buttons {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
    }


    .time-field [type="text"] {

        @media all and (min-width: $breakpoint + 1) {
            max-width: 218px;
            padding-right: calc(96px + 24px);
        }

        @media all and (max-width: $breakpoint) {
            padding-right: calc(96px + 15px);
        }
    }


    .field-inputs [type="radio"] {
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
    }


    .field-inputs .buttons {
        background-color: $accent;
    }


    .field-inputs .buttons label {
        line-height: 48px;
        text-align: center;
        font-weight: $medium;
        cursor: pointer;
    }

    .buttons > :first-child label {
        padding: 0 8px 0 21px
    }

    .buttons > :last-child label {
        padding: 0 21px 0 8px
    }

    [type="radio"]:checked + label {
        color: #FFF;
    }

    [type="radio"]:not(:checked) + label {
        color: rgba(#FFF, 0.5);
    }


    .budget-field .currency {
        background-color: $accent;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 50%;
        max-width: 103px;
        line-height: 48px;
        text-align: center;
        font-weight: $medium;
        font-size: 14px;
        color: #FFF;
    }

    .budget-field [type="text"] {
        max-width: 347px;

        @media all and (min-width: $breakpoint + 1) {
            padding-left: 103px + 20px;
        }

        @media all and (max-width: $breakpoint) {
            padding-left: 103px + 15px;
        }
    }


    .drag-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 183px;
        border: 1px dashed $dark-gray;
    }


    .drag-container button {
        font-weight: $medium;
        font-size: 14px;
        color: $dark-gray;
    }


    .drag-container .picture-icon {
        display: block;
        margin: 0 auto 4px;
        width: 36px;
        height: 36px;
    }


    .add-more-btn {
        display: block;
        margin-top: 71px;
        width: 100%;
        height: 48px;
        line-height: 48px;
        text-transform: uppercase;
        text-align: center;
        font-weight: $heavy;
        font-size: 14px;
        color: #FFF;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }

    .add-more-btn:not(.main-btn) {
        background-color: $dark-gray;
    }

    .section h4 + .add-more-btn {

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 64px;
        }
    }


    .activity-buttons {
        display: flex;
        margin-top: 70px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            flex-wrap: wrap;
        }
    }


    .activity-buttons button {
        padding: 0 33px;

        @media all and (max-width: $breakpoint) {
            width: 100%;
        }
    }

    .activity-buttons button:not(:first-child) {

        @media all and (min-width: $breakpoint + 1) {
            margin-left: 24px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .cancel-btn {
        margin-top: 24px;
        text-transform: uppercase;
        font-weight: $heavy;
        font-size: 16px;
        color: $dark-gray;

        @media all and (max-width: $breakpoint) {
            width: 100%;
        }
    }


    .section > .pagination {

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 70px;
            justify-content: flex-end;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .section .rectangle {
        background-color: $light-gray;
        margin: 55px auto 0;
        width: 100%;
        max-width: 480px;
        height: 100vh;
        max-height: 415px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            max-height: 200px;
        }
    }


    .section h4 {
        margin: 32px auto 0;
        text-align: center;
        font-weight: $heavy;
        font-size: 32px;
        color: $dark-gray;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            order: 2;
            font-size: 16px;
        }
    }
</style>
